// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4764":"66b504a4","6748":"c3a71a48"}[chunkId] + ".chunk.css";
};